module.exports = __webpack_public_path__ + "static/media/m_w_hb_18.34f5b051.png";